import AvailabilityFetchVM from './AvailabilityFetchTSVM';
import * as dateFunctions from '@Functions/DateFunctions';

const todayDate = new Date();
todayDate.setHours(0, 0, 0);
const today = dateFunctions.computeLtDateFromDate(todayDate) as number;

export class DateEntry {

    day: number;
    month: number;
    year: number;
    classes: Array<string>;
    key: string;
    ltDate: number;

    constructor(day: number, month: number, year: number) {

        this.day = day;
        this.month = month;
        this.year = year;
        this.key = `${year}-${(month+1)}-${day}`;
        this.classes = [];

        this.ltDate = dateFunctions.computeLtDate(this.day, month, year);
    }


    /**
     * set data based on availability. should be set only once per run.
     * @param aval
     */
    public updateForAvailability(aval: AvailabilityFetchVM | undefined) {


        if (aval) {

            const checkArrival = true;
            let isAvailable = false;
            let isValidArrival = false;

            for (const ent of aval.entries) {

                if (!isAvailable && (this.ltDate >= ent[0] && this.ltDate <= ent[ent.length - 1])) {

                    // if the current date is inside this entry, then the accommodation is available.
                    isAvailable = true;
                }

                if (checkArrival && !isValidArrival && this.ltDate === ent[0]) {

                    isValidArrival = true;
                }

                // if we have set both isAvailable, and isValidArrival, and
                // we dont need to check valid departure, then we can stop.
                if (checkArrival && isAvailable && isValidArrival) break;


            }

            if (isAvailable) {
                // entry.classes.push("-v");
            } else {
                this.classes.push("-x");
            }

            if (isValidArrival) {
                this.classes.push("-a");
            }


        } else {

            // for non accommodation, so what we do here is only check using "today"
            // and perhaps a cap for max duration (?)
            if (this.ltDate <= (today + 2)) { // plus 2 -- beause in the accommodation calendar we use addDays 3 (inclusive) to fetch availability
                this.classes.push("-x");
            } else {
                this.classes.push("-a");
            }
        }
    };
}



